import { UserManager, UserManagerSettings } from "oidc-client";
//Extended UserManger to change the signinRedirect behaviour. 
//If the user is clinicaluser and args.prompt is login then it should redirct to custom clinical login page
export class MedsUserManager extends UserManager {
    private _isClinicalIdentityProviderUser?: boolean;

    constructor(
        settings: UserManagerSettings,
        isClinicalIdentityProviderUser?: boolean
    ) {
        super(settings);
        this._isClinicalIdentityProviderUser = isClinicalIdentityProviderUser;
    }
    signinRedirect(args?: any): Promise<any> {        

        //args?.prompt value is set by communicare to login and they are using this to redirct user to login page while S8 prescription.
        //No where else they are using this. If they change this in future we need to change the value to match their value.
        if (this._isClinicalIdentityProviderUser && args?.prompt == 'login') {
            window.location.href =
                window.location.origin + `/relogin?redirct_uri=` + window.location.href;

            return Promise.resolve();
        }
        else return super.signinRedirect(args);
    }
}